import { render, staticRenderFns } from "./DiscountCoupon.vue?vue&type=template&id=0cc35ff7&"
import script from "./DiscountCoupon.vue?vue&type=script&lang=js&"
export * from "./DiscountCoupon.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports